var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostItRekenregels(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f{fill:url(#d);}.g{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -63.46,
    y1: 838.98,
    x2: -64.36,
    y2: 840.05,
    gradientTransform: "translate(5849.06 76597.85) scale(90.79 -91.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffefe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fde0c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fde0c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -63.92,
    y1: 839.03,
    x2: -63.92,
    y2: 840.12,
    gradientTransform: "translate(5803.95 14486.28) scale(90.02 -17.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4d7be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fde0c7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "c",
    className: "g",
    d: "M94.69,87.79c6.03-7.68,4.94-21.6,4.94-37,0-13.16,.15-30.42,.15-50.79H1.3S.22,88.06,.22,98.88c25.5,0,43.65,1.12,57.41,1.12,12.32,0,21.1-.9,28.53-5.13l8.53-7.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "e",
    className: "f",
    d: "M99.78,0l-.04,18.91H1.07L1.3,0H99.78Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostItRekenregels);
export default __webpack_public_path__ + "static/media/Post-it-rekenregels.f848caf6fc4b54eb3af8d46ee321a8b8.svg";
export { ForwardRef as ReactComponent };